import { Card, ImageList, ImageListItem, ImageListItemBar } from "@mui/material";

const imageData = [
  {
    img: 'atlassian_jira_logo.png',
    title: 'Jira',
    key: 'Jira'
  },
  {
    img: 'azure_devops_logo.png',
    title: 'Azure Devops',
    key: 'Azure'
  }
]

export default function APISelect({ handleToolSelect }: any) {

  return (
    <ImageList cols={imageData.length} sx={{ display: 'flex', justifyContent: 'space-evenly', paddingBottom: '0.5em' }} >
      {imageData.map((item: { img: string, title: string, key:string }, index: number) =>
        <Card key={index + ""} elevation={4} style={{ padding: '0.3em', cursor: 'pointer', display:'flex', alignContent:'center' }}>
          <ImageListItem
            key={item.img}
            sx={{ width: 200, height: 200 }}
            component=''
            onClick={() => handleToolSelect(item.key)}
          >
            <img src={"./assets/images/" + item.img} alt={item.title} />
            <ImageListItemBar title={item.title} position="bottom" style={{textAlign:'center'}} />
          </ImageListItem>
        </Card>
      )}
    </ImageList>
  );
}